// Older active servers do not expose the optional commerce capability endpoint.
// Only that explicit absence is compatible; auth, network and server errors remain errors.
export async function optionalFleetAccess(session) {
  try { return await session.fleetAccess(); }
  catch (error) {
    if (error?.code !== 'not_found') throw error;
    return {enforced:false,organizations:[],plans:[]};
  }
}
